var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c(
        "div",
        { staticClass: "comment-replies" },
        [
          _c("Header"),
          _vm._v(" "),
          _vm.hasComments ? _c("Tabs") : _vm._e(),
          _vm._v(" "),
          _c("Input"),
          _vm._v(" "),
          _c("RootCommentList", { ref: "rootCommentList" }),
          _vm._v(" "),
          _c("ModalWithError")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }